import { render, staticRenderFns } from "./JSwitch.vue?vue&type=template&id=d4dc1e7a"
import script from "./JSwitch.vue?vue&type=script&lang=js"
export * from "./JSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports